/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateManagementListContainer as TemplateManagementList } from './TemplateManagementList.container';
